<template>
    <div class="c-o-my-pages-section">
        <div class="c-o-my-pages-section__inner">
            <h2 class="c-o-my-pages-section__heading">Aktiva tjänster</h2>
            <div>
                <div class="c-o-table">
                    <table class="c-o-table__table">
                        <thead class="c-o-table__thead">
                            <tr v-if="isDesktop" class="c-o-table__tr">
                                <th class="c-o-table__th">Typ</th>
                                <th class="c-o-table__th">Pris</th>
                                <th class="c-o-table__th">Startdatum</th>
                                <th class="c-o-table__th">Slutdatum</th>
                                <th class="c-o-table__th">Status</th>
                            </tr>
                            <tr v-else class="c-o-table__tr">
                                <th class="c-o-table__th" colspan="5">Aktiva tjänster</th>
                            </tr>
                        </thead>
                        <tbody class="c-o-table__tbody">
                            <tr v-for="service in activeServices" :key="`service-id-${service.Id}`" class="c-o-table__tr c-o-table__tr--flip-at-small">
                                <td class="c-o-table__td">
                                    <span v-if="!isDesktop" class="c-o-table__inline-label">Abonnemang:</span>
                                    {{service.Name}}
                                </td>
                                <td class="c-o-table__td">
                                    <span v-if="!isDesktop" class="c-o-table__inline-label">Pris (ex.moms):</span>
                                    {{service.Price}} kr
                                </td>
                                <td class="c-o-table__td">
                                    <span v-if="!isDesktop" class="c-o-table__inline-label">Startdatum:</span>
                                    {{service.StartDate | formatDateWithoutTime}}
                                </td>
                                <td class="c-o-table__td">
                                    <span v-if="!isDesktop" class="c-o-table__inline-label">Slutdatum:</span>
                                    {{service.EndDate | formatDateWithoutTime}}
                                </td>
                                <td class="c-o-table__td">
                                    <span v-if="!isDesktop" class="c-o-table__inline-label">Status:</span>
                                    {{service.Status.Name}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Filters from '../../../../../../filters/index.js'

    export default {
        props: [
            'companyServices'
        ],
        filters: Filters,
        computed: {
            activeServices: function(){
                return this.companyServices.filter(item => item.Status.Id < 4 );
            },
            isDesktop: function() {
                return this.$mq === 'medium' || this.$mq === 'large' || this.$mq === 'xLarge' ? true : false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/company/account/OrganismMyPagesAccountServices.vue